import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const SecurityManagementEntry = () => {
  useModuleRedirect("security-module");
  return null;
};

export default SecurityManagementEntry;